import { axiosConfig } from './axios-config.js'

export const onePage = {
  // 取得關於我們
  getAbout: (token) => axiosConfig.get('/api/console/about', token),

  // 更新關於我們
  updateAbout: (data, token) => axiosConfig.post('/api/console/about', data, token),

  // 取得常見問答
  getQa: (token) => axiosConfig.get('/api/console/qa', token),

  // 更新常見問答
  updateQa: (data, token) => axiosConfig.post('/api/console/qa', data, token),

  // 取得關於法律與隱私
  getPolicy: (token) => axiosConfig.get('/api/console/policy', token),

  // 更新關於法律與隱私
  updatePolicy: (data, token) => axiosConfig.post('/api/console/policy', data, token),

  // 取得注意事項
  getNotice: (token) => axiosConfig.get('/api/console/other', token),

  // 更新注意事項
  updateNotice: (data, token) => axiosConfig.post('/api/console/other', data, token)
}
